<!-- complete-profile.component.html - Simplified Single-Field Onboarding -->
<div class="profile-container">
    <p-toast></p-toast>

    <!-- Simple Welcome Header -->
    <div class="welcome-header">
        <div class="header-content">
            <div class="logo-section">
                <h1 class="brand-name">Anchored Growth</h1>
            </div>
            <a href="#" class="logout-link" (click)="logout($event)">Logout</a>
        </div>
    </div>

    <!-- Main Content Card -->
    <p-card [styleClass]="'onboarding-card'" *ngIf="!isComplete">
        <div class="onboarding-content">
            <!-- Welcome Message -->
            <div class="welcome-section">
                <div class="welcome-icon">
                    <i class="pi pi-sparkles"></i>
                </div>
                <h2>Welcome! Let's get started.</h2>
                <p>Create your workspace to begin your 14-day free trial.</p>
            </div>

            <!-- Account Type Selector -->
            <div class="type-selector">
                <div class="type-card" [class.selected]="selectedType === 'company'" (click)="selectType('company')">
                    <div class="type-icon">
                        <i class="pi pi-building"></i>
                    </div>
                    <div class="type-label">Company</div>
                    <div class="type-desc">Single company or team</div>
                </div>
                <div class="type-card" [class.selected]="selectedType === 'agency'" (click)="selectType('agency')">
                    <div class="type-icon">
                        <i class="pi pi-sitemap"></i>
                    </div>
                    <div class="type-label">Agency</div>
                    <div class="type-desc">Manage multiple client accounts</div>
                </div>
            </div>

            <!-- Simple Form -->
            <form [formGroup]="workspaceForm" (ngSubmit)="submitProfile()" class="workspace-form">
                <div class="form-field">
                    <label for="workspaceName">
                        {{ selectedType === 'agency' ? "What's your agency name?" : 'What should we call your workspace?' }}
                    </label>
                    <input
                        id="workspaceName"
                        type="text"
                        pInputText
                        formControlName="workspaceName"
                        [placeholder]="selectedType === 'agency' ? 'e.g., Growth Partners, Digital Agency' : 'e.g., Acme Corp, My Team, Sales Outreach'"
                        class="workspace-input"
                        autofocus />
                    <small class="field-hint" *ngIf="!isFormControlInvalid('workspaceName')">
                        {{ selectedType === 'agency' ? 'You can add client accounts after setup' : 'This is typically your company or team name' }}
                    </small>
                    <small class="p-error" *ngIf="isFormControlInvalid('workspaceName')">
                        Please enter a {{ selectedType === 'agency' ? 'agency' : 'workspace' }} name (2-100 characters)
                    </small>
                </div>

                <button
                    pButton
                    type="submit"
                    label="Start Free Trial"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    class="submit-button"
                    [loading]="loading"
                    [disabled]="loading">
                </button>
            </form>

            <!-- Trial Info -->
            <div class="trial-info">
                <div class="trial-badge">
                    <i class="pi pi-check-circle"></i>
                    <span>14-day free trial included</span>
                </div>
                <ul class="trial-benefits">
                    <li><i class="pi pi-check"></i> 1 campaign, 1 integration, 1 pattern</li>
                    <li><i class="pi pi-check"></i> 5 AI credits, 1 GB storage</li>
                    <li><i class="pi pi-check"></i> No credit card required</li>
                </ul>
            </div>
        </div>
    </p-card>

    <!-- Success State -->
    <p-card [styleClass]="'onboarding-card success-card'" *ngIf="isComplete">
        <div class="success-content">
            <div class="success-icon">
                <i class="pi pi-check-circle"></i>
            </div>
            <h2>Workspace Created!</h2>
            <p>Your 14-day free trial has started. Taking you to your dashboard...</p>
            <p-progressBar mode="indeterminate" [style]="{'height': '4px', 'width': '200px', 'margin': '0 auto'}"></p-progressBar>
        </div>
    </p-card>
</div>
